module.exports = __webpack_public_path__ + "static/media/portrait-photo-product.e8d8f8c0.jpg";